export enum StepAddPayerEnum {
    getDescriminator = 1,
    basicInformation = 2
}